export default {
  mensajes: {
    inicial: 'Hi!',
    descripcion: 'Request your quote easily and quickly in just three steps.',
    resumen: 'View summary',
    cuestionario: {
        titulo: 'Tell us about your experience',
        introduccion: 'Your feedback helps us improve and maintain the quality of every service on your trip.',
        cargando: 'We are preparing your questionnaire…',
        enlace_invalido: 'This link does not match any booking.',
        error_carga: 'We could not load the questionnaire. Please try again later.',
        error_envio: 'We could not send your answers. Please try again.',
        no_disponible: 'The questionnaire will be available once your trip has ended.',
        disponible_desde: 'You can complete it from {fecha}.',
        sin_preguntas: 'There are no questions available for the services in this booking.',
        gracias: 'Thank you for sharing your experience!',
        enviado_correctamente: 'Your answers have been saved successfully.',
        bloques_guardados: '1 review has been saved. You can complete the remaining ones. | {count} reviews have been saved. You can complete the remaining ones.',
        comentario: 'Would you like to tell us anything else? (optional)',
        de_diez: 'out of 10',
        enviar: 'Send my answers',
        responde_una: 'Answer at least one question before sending.',
        secciones: {
          rutas_meigas: 'Rutas Meigas',
          alojamientos: 'Accommodation',
          servicios: 'Services',
        },
        tipos: {
          general: 'Rutas Meigas',
          alojamiento: 'Accommodation',
          servicio: 'Service',
        },
    },
    login: {
      agencias: 'AGENCIES',
      trabaja_con_nosotros: 'Would you like to work with us as an agency?',
      descripcion_registro: 'Leave us your details and we will contact you to set up your agency account.',
      contactar: 'Contact us',
      agencia_requerida: 'Agency (*)',
      responsable_requerido: 'Contact person (*)',
      email_requerido: 'Email (*)',
      telefono_requerido: 'Phone number (*)',
      mensaje_opcional: 'Message (optional)',
      solicitud_enviada: 'Your request has been sent successfully. We will contact you shortly. Thank you for your interest.',
      enviando: 'Sending...',
      enviar_solicitud: 'Send request',
      agencia_registrada: 'Are you already a registered agency?',
      accede_con_tus_datos: 'Sign in with your details',
      nombre: 'Name',
      contrasena: 'Password',
      accediendo: 'Signing in...',
      acceder: 'Sign in',
      error_campos_obligatorios: 'Please complete the agency, contact person, email and phone number fields.',
      error_email_invalido: 'The email address is not valid.',
      error_solicitud: 'The request could not be sent. Please try again.',
    },
    central_reservas: {
      nueva_solicitud: 'New request',
      expedientes_menu: 'Bookings',
      expedientes: 'Bookings',
      proformas: 'Proformas',
      invoices_menu: 'Invoices',
      perfil_agencia: 'Agency profile',
      ayuda: 'Help',
      cerrar_sesion: 'Sign out',
      selecciona_camino: 'Select a Camino',
      selecciona_agencia_origen: 'Select the source agency',
      idioma_documentacion: 'Booking document language',
      idioma_es: 'Spanish',
      idioma_en: 'English',
      idioma_de: 'German',
      cambiar_idioma: 'Change language',
      nombre_agencia: 'Agency name',
      telefono_agencia: 'Agency phone number',
      email_agencia: 'Agency email',
      instrucciones_cliente: 'Please enter your client\'s details below.\n\nWhen you request the proposal, the quote will be sent to both the agency\'s email address and the client\'s email address.',
      instrucciones_cliente_pendientes: 'When you request the proposal, the quote will be sent to the agency\'s email address. The Rutas team will send you the complete proposal with the services pending quotation as soon as possible.\n\nPlease enter your client\'s details below.',
      nombre_cliente: 'Client\'s name',
      apellidos_cliente: 'Client\'s surname',
      email_cliente: 'Client\'s email',
      aviso_cliente_servicios_pendientes: '*Please note that, because there are extra services pending quotation, the client will not receive a copy of this request.',
      enviar_propuesta_cliente: 'Send proposal to client',
      recibir_propuesta: 'Receive proposal',
      expedientes: {
        refrescar: 'Refresh',
        reservas_por_pagina: 'Bookings per page',
        codigo: 'Code',
        referencia_agencia: 'Agency ref.',
        fecha_inicio: 'Start date',
        fechas_camino: 'Camino dates',
        estado: 'Status',
        cliente: 'Client',
        cliente_camino: 'Client / Camino',
        solicitud: 'Request',
        peregrinos: 'Pilgrims',
        peregrinos_corto: 'Pax',
        habitaciones: 'Rooms',
        habitaciones_corto: 'Rooms',
        ver_detalle: 'View details',
        sin_datos: 'No data available',
        cargando_detalle: 'Loading booking details...',
        detalle_reserva: 'Booking details',
        ver_historial: 'View history',
        agente_asignado: 'Assigned agent',
        agente: 'Agent',
        codigo_interno: 'Internal code',
        inicio: 'Start',
        llegada: 'Arrival',
        idioma: 'Language',
        editar: 'Edit',
        cancelar: 'Cancel',
        guardar: 'Save',
        cliente_actualizado: 'Client details updated successfully.',
        importe_reserva_pvp: 'Booking amount (RRP)',
        comision_agencia: '15% Agency commission',
        importe_neto_agencia: 'Net agency amount',
        servicios_agregados_neto: 'Additional services (Net)',
        importe_total_pvp: 'Total amount (RRP)',
        importe_total_neto: 'Total amount (Net)',
        pasajeros: 'Travelers',
        modificar_pasajeros: 'Edit travelers',
        sin_pasajeros: 'There are no travelers registered for this booking',
        archivos_reserva: 'Booking files',
        archivos_seleccionados: '0 selected | 1 selected | {count} selected',
        enviar_archivos: 'Send files',
        fecha: 'Date',
        documento: 'Document',
        nombre: 'Name',
        tipo_documento: 'Document type',
        numero_documento: 'Document no.',
        movil: 'Mobile',
        ver: 'View',
        enviar: 'Send',
        enviar_cliente: 'Send to client',
        solicitar_modificacion: 'Request changes',
        solicitar_confirmacion: 'Request confirmation',
        sin_archivos: 'There are no files in this section',
        error_cargar_detalle: 'The booking details could not be loaded.',
        correo_enviado: 'Email sent successfully.',
        documentos_seleccionados: 'Selected documents',
        para: 'To',
        asunto: 'Subject',
        texto_correo: 'Email text',
        mensaje_agencia: 'Message to send to the agency',
        detalle_correo: 'Email details',
        documentos_adjuntos: 'Attached documents',
        historial_reserva: 'Booking history',
        usuario: 'User',
        descripcion: 'Description',
        mensaje: 'Message',
        adjunto: 'Attachment',
        sin_estado: 'NO STATUS',
        historial_agencia_rutas: 'History {agencia} <=> Rutas Meigas',
        historial_agencia_cliente: 'History {agencia} <=> Client',
        ver_documento: 'View document',
        sin_acciones_historial: 'There are no actions registered in the history',
      },
      invoices: {
        titulo: 'Invoices',
        descripcion: 'List of invoices issued for the agency.',
        registros: '0 records | 1 record | {count} records',
        sin_facturas: 'There are no invoices available for this agency.',
        filtrar_fecha: 'Filter by date',
        filtrar_expediente: 'Filter by booking',
        filtrar_documento: 'Filter by document',
        fecha: 'Date',
        expediente: 'Booking',
        tipo: 'Type',
        factura: 'INVOICE',
        ver: 'View',
        error_agencia: 'The agency could not be identified to load invoices.',
        error_carga: 'Invoices could not be loaded. Please try again.',
      },
      perfil: {
        titulo: 'Agency profile', descripcion: 'Agency information linked to the authenticated user.', agencia_activa: 'Active agency', refrescar: 'Refresh', guardar: 'Save', sin_agencia: 'The profile cannot be saved without identifying the agency.', aviso_completar: 'All agency profile details must be completed before continuing.', cambiar_logo: 'Change logo', campo_obligatorio: 'Required field', comision: 'Commission', datos_generales: 'General details', nombre: 'Name', responsable: 'Contact person', telefono_2: 'Phone number 2', direccion: 'Address', codigo_postal: 'Postal code', poblacion: 'City', provincia: 'Province', pais: 'Country', datos_fiscales: 'Tax details', nombre_fiscal: 'Legal name', direccion_fiscal: 'Legal address', codigo_postal_fiscal: 'Legal postal code', poblacion_fiscal: 'Legal city', provincia_fiscal: 'Legal province', pais_fiscal: 'Legal country', usuarios_asociados: 'Associated users', sin_usuarios: 'There are no associated users.', caminos_permitidos: 'Allowed Caminos', camino: 'Camino', sin_caminos: 'There are no associated Caminos.', error_refrescar: 'The agency profile could not be refreshed. Please try again.', exito_guardar: 'Agency profile saved successfully.', error_guardar: 'The agency profile could not be saved. Please try again.', error_imagen_invalida: 'The selected file is not a valid image.', error_procesar_imagen: 'The selected image could not be processed.'
      },
      ayuda_contenido: {
        titulo: 'Help centre', descripcion: 'Find quick answers by topic or search frequently asked questions.', buscar: 'Search help', temas: 'Help topics', preguntas: '0 questions | 1 question | {count} questions', mas_ayuda: 'Need more help?', contacto: 'If you cannot find the answer, you can contact us at this email address.', general: 'General', general_descripcion: 'General information about how the application works.', solicitudes: 'New request', solicitudes_descripcion: 'Creating bookings, dates, rooms and prices.', expedientes: 'Bookings', expedientes_descripcion: 'Search, filters and statuses for existing bookings.', cuenta: 'Account and access', cuenta_descripcion: 'Sign-in, agency profile and security.', video_tutorial: 'Video tutorial', video_ayuda: 'Help video', preguntas_frecuentes: 'Frequently asked questions', sin_resultados: 'No questions were found for the selected filters.',
        faqs: {
          general: {
            1: { pregunta: 'Which modules are included in the Booking Centre?', respuesta: '<p>The application is organised into modules such as help, new request, bookings, and account/access.</p><p>Each module groups specific day-to-day functions.</p>' },
            2: { pregunta: 'How can I quickly find a feature in the application?', respuesta: '<p>Use the side menu to switch modules.</p><p>In the help centre you will find videos and frequently asked questions specific to each area.</p>' },
            3: { pregunta: 'What should I do if a list or form does not show the expected information?', respuesta: '<p>First check:</p><ul><li>Active filters</li><li>Current page</li><li>Outstanding required fields</li></ul><p>If the problem persists, contact support with the agency, module, and error context.</p>' }
          },
          solicitudes: {
            1: { pregunta: 'Which fields are mandatory when creating a request?', respuesta: '<p>You must complete the camino, language, date, rooms, pilgrims, and the <strong>Agency booking reference</strong> field.</p>' },
            2: { pregunta: 'When are prices recalculated?', respuesta: '<p>Prices are recalculated automatically when you change:</p><ul><li>Camino</li><li>Dates</li><li>Number of rooms</li></ul>' },
            3: { pregunta: 'Why can I not proceed to the next step?', respuesta: '<p>This is usually due to one of these reasons:</p><ul><li>A required field is missing</li><li>There is no valid distribution of rooms and pilgrims</li></ul>' },
            4: { pregunta: 'How should I correctly allocate the number of rooms?', respuesta: '<p>The total number of rooms must be consistent with the number of pilgrims.</p><p>If the distribution does not match, the system will not let you continue to the next step.</p>' },
            5: { pregunta: 'Can I edit a request before sending it?', respuesta: '<p>Yes. Until you confirm the final step, you can:</p><ul><li>Go back</li><li>Change dates</li><li>Modify rooms</li><li>Update customer details</li></ul>' },
            6: { pregunta: 'What happens if availability or a price is not displayed?', respuesta: '<p>This is usually due to an invalid combination of dates, occupancy, or services.</p><p>Check the camino, language, and room allocation before trying again.</p>' }
          },
          expedientes: {
            1: { pregunta: 'Which filters can I use in Bookings?', respuesta: '<p>You can filter by:</p><ul><li>Code</li><li>Agency code</li><li>Start date</li><li>Status</li><li>Customer</li><li>Request</li><li>Pilgrims</li><li>Rooms</li></ul>' },
            2: { pregunta: 'What does a booking status mean?', respuesta: '<p>The status indicates its operational stage, for example <strong>REQUESTED</strong>, <strong>QUOTED</strong>, or <strong>CONFIRMED</strong>.</p><p>It is also shown with its corresponding colour in the table and detail view.</p>' },
            3: { pregunta: 'Why can I not see some bookings?', respuesta: '<p>The list applies rules based on the logged-in user’s origin.</p><p>If you are an agency, you will only see bookings from your own origin.</p>' },
            4: { pregunta: 'How are table filters applied?', respuesta: '<p>Each column has its own filter.</p><p>When you press <strong>Enter</strong> or clear the field with the <strong>clear</strong> icon, the list queries the endpoint again with the updated parameters.</p>' },
            5: { pregunta: 'How does column sorting work?', respuesta: '<p>You can sort by:</p><ul><li>Code</li><li>Agency reference</li><li>Camino dates</li><li>Status</li><li>Customer</li><li>Request</li><li>Pilgrims</li><li>Rooms</li></ul><p>Sorting is performed on the server.</p>' },
            6: { pregunta: 'What should I do if I open a detail and want to return to the list?', respuesta: '<p>Close the detail dialog to continue working in the table.</p><p>The list filters, page, and sorting are preserved.</p>' }
          },
          cuenta: {
            1: { pregunta: 'How do I sign out securely?', respuesta: '<p>Use the <strong>Sign out</strong> option in the side menu.</p><p>This invalidates your session and returns you to the login screen.</p>' },
            2: { pregunta: 'What should I do if I forgot my credentials?', respuesta: '<p>Contact administration to restore access.</p><p>Provide the agency, email address, and contact telephone number.</p>' },
            3: { pregunta: 'Where can I review or update my agency details?', respuesta: '<p>In the agency profile module you can review:</p><ul><li>Main information</li><li>Logo</li><li>Other data associated with your account</li></ul>' },
            4: { pregunta: 'Why might my session close automatically?', respuesta: '<p>For security, your session may expire after a period of inactivity or if the token is no longer valid.</p><p>In that case, you will need to sign in again.</p>' },
            5: { pregunta: 'Who should I contact if I find a technical problem?', respuesta: '<p>You can write to <strong>sistemas@rutasmeigas.com</strong>.</p><p>Include the agency, affected booking if applicable, and a short description of the problem.</p>' }
          }
        }
      },
    },
  
    datos_de_reserva: 'Booking details',
    datos_personales: 'Personal information',
    resumen_reserva: 'Your quote has been sent!',
  
    preguntaPaso1: 'We need the following basic information to arrange your camino: arrival date, number of pilgrims, and number of rooms by type.',
  
    datos_reserva: {
      fechas_seleccion: 'Arrival and departure date',
      
      habitaciones_individuales: 'Single rooms',
      habitaciones_dobles: 'Double rooms (2_single_beds)',
      habitaciones_dobles_matrimoniales: 'Double rooms (1_matrimonial_bed)',
      habitaciones_triples: 'Triple rooms',
      cantidad_de_peregrinos: 'Number of pilgrims',

      titulo: 'Booking details',
      fecha_inicio: 'Arrival date:',
      fecha_llegada: 'Departure date:',
      habitaciones: 'Rooms:',
      peregrinos: 'Pilgrims:',
      comentarios: 'Tell us any additional information.\nDo you have children? Tell us their ages.\nDo you have pets? Tell us what pet it is and its weight.',
  
      importe_reserva: 'Basic booking amount:',
      servicios_agregados: 'Additional services:',
      importe_total: 'Total amount:',
      comision_agencia: '15% Agency commission:',
      importe_neto_agencia: 'Net agency amount:',
      no_comisionable: '(Not commissionable)',
      precio_por_peregrino: '€/Pilgrim',
    },

    servicios: {
      tab_servicios: 'Services',
      incluidos_titulo: 'Included services',
      incluidos_subtitulo: 'If you want to cancel any of the included services, you can remove it.',
      opcionales_titulo: 'Optional services',
      pendiente_de_tarifa: 'Pending',
      subtitulo_desde: '(From {tarifa}€)',
      subtitulo_por_persona: '({tarifa}€ x pilgrim)',
      subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} pilgrims)',
      noche_extra_en: 'Extra night in',
      traslado_extra: 'Extra transfer',
      servicio_extra: 'Extra service',
      ver_incluidos_boton: 'View included services',
    },

    siguientePaso1: 'Next',

    preguntaPaso2: 'Now we need your details to send you the quote as soon as possible.',
    nombre: 'Name',
    apellidos: 'Surname',
    telefono: 'Phonenumber',
    email: 'E-mail',

    politica_privacidad: 'I accept the ',
    politica_privacidad_texto_enlace: 'privacy policy',
    politica_privacidad_enlace: 'https://rutasmeigas.com/privacy-policy',

    acepta_novedades: 'I agree to receive latest news.',

    recibir_presupuesto: 'Receive quote',
    enviando_presupuesto: 'Sending quote...',
    presupuesto_enviado: 'QUOTE SEND!',
   
    registro_individual: {"titulo": "Traveller registration", "reserva": "Booking", "descripcion": "Complete your personal details to prepare your trip.", "completado": "Your details have been saved. You can view them here.", "guardar": "Save my details", "cargando": "Loading", "reintentar": "Try again", "recargar": "Reload form", "noDisponible": "This link is unavailable.", "errorCarga": "The registration could not be loaded.", "errorEnvio": "The details could not be saved. Check the fields or try again.", "obligatorio": "Required field", "email": "Enter a valid email address", "fecha": "Enter a valid date that is not in the future (DD/MM/YYYY)"},
    datos_pasajeros: {
      conflicto_guardado: 'The traveller details have changed since you opened this form. Reload the page before saving. Your changes have not been saved yet.',
      error_guardado: 'The details could not be saved. Please try again.',
      titulo: "In accordance with current Spanish legislation (Royal Decree 933/2021 of October 26) which establishes the obligations of documentary registration and information of natural or legal persons that carry out lodging activities (travel agencies, hotel establishments and rental companies of vehicles) we must provide the following data to the Ministry of the Interior (Government of Spain).",
      subtitulo: 'To manage your booking, we need the complete details of all the pilgrims who will be participate at the Camino de Santiago. Please fill out each form with the requested information.<br>It is important that the details are accurate and complete, as we will use them to organize the trip, reserve accommodations, and other services.<br>Once you have completed all the information, we will proceed to confirm your booking. If you have any questions, please don’t hesitate to contact us.',
      datos_peregrino: 'Traveler {index}',
      confirmar_datos: 'Confirm details',
      guardar_datos: 'Save travelers data',
      mensaje_final_success: 'Thank you. The data of the travelers has been saved correctly.',
      pagar: 'Pay',
      mensaje_confirmacion_pasajero_y_pago: 'Your data has been sent correctly. We inform you that the total amount of the reservation is {importe} €.<br>You can now make a 100€ advance payment for the reservation.',
      pago_realizado: 'Payment made correctly',


      nombre: 'Name',
      primer_apellido: 'First Surname',
      segundo_apellido: 'Second Surname',
      sexo: 'Sex',
      sexo_opciones: {
        hombre: 'Male',
        mujer: 'Female',
        no_decir: 'Prefer not to say',
      },
      fecha_nacimiento: 'Date of Birth',
      tipo_documento: 'Document Type',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'Passport',
      },
      numero_documento: 'Document Number',
      soporte_documento: 'Document Support',
      telefono_fijo: 'Fixed Phone',
      telefono_movil: 'Mobile Phone',
      email: 'Email',
      direccion: 'Address',
      poblacion: 'Population',
      provincia: 'Province',
      codigo_postal: 'Postal Code',
      nacionalidad: 'Nationality',
      parentesco: 'Relationship',

      pago_realizado_subtitulo: 'Thank you for trusting us.<br>We will contact you to confirm the details of your reservation.',
      politica_privacidad: `Responsible for processing: RUTAS MEIGAS SL CIF: B15649270 Postal address: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Telephone: 881019941 E-mail: info@rutasmeigas.com 
      Purpose of the processing of your data: In accordance with the provisions of current legislation on the Protection of Personal Data, Regulation 2016/679 General Data Protection Regulation (RGPD) and Organic Law 3/2018 of 5 December, on the protection of personal data and guarantee of digital rights (LOPDGDD), we inform you that the purpose of the processing of your data is to carry out the management of your reservation.
      Legitimation: Article 6.1.a) of the GDPR. The data subject consented to the processing of his or her personal data for one or more specific purposes. Article 6.1.b) of the GDPR. Processing necessary for the performance of a contract to which the data subject is a party or for the implementation at the request of the data subject of pre-contractual measures. Article 6.1.c) of the GDPR: processing is necessary for compliance with a legal obligation applicable to the controller: Royal Decree 933/2021 of 26 October establishing the documentary registration and information obligations of natural or legal persons carrying out accommodation and motor vehicle rental activities. Article 45 of the Schengen Agreement of June 1985 Organic Law 4/2015 of 30 March 2015 on the protection of citizen security.
      Conservation and treatment of data: The data provided will be kept as long as you do not request its cancellation, or for the time necessary to comply with legal obligations and to meet any possible liabilities that may arise from the fulfilment of the purpose for which the data was collected. Your data will be transferred to the different wholesale companies with which the entity operates, as well as to airlines, hotel establishments, car rental companies and/or tour operators, where applicable, for the purpose of contracting their services or requesting information on availability and prices. These providers, depending on the country of your travel destination, may be located in countries that do not have a similar level of data protection to that existing in the EU, for which the transfer is necessary for the purpose of executing contractual measures. They may also be transferred to other companies with which RUTAS MEIGAS SL works/collaborates in order to carry out the corresponding procedures and/or services. Other data will not be transferred to third parties except in cases where there is a legal obligation. RUTAS MEIGAS SL will not elaborate any type of 'profile' based on the information provided. No automated decisions will be made on the basis of profiles.
      Rights: You may exercise your rights of access, rectification, deletion, opposition, limitation of processing, data portability and the right not to be subject to automated individualised decisions, in relation to the data being processed, before the data controller at the address RÚA LISBOA 16 BAJO IZDA - 15707 - SANTIAGO DE COMPOSTELA or by e-mail to info@rutasmeigas.com, attaching a copy of your ID card or equivalent document. In the event that you have not obtained satisfaction in the exercise of your rights, you may lodge a complaint with the competent Data Protection Control Authority, which is the Spanish Data Protection Agency, whose contact details are available at https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf`
    },

    ir_al_camino: 'More details of the Camino',

    enviar_consulta: 'Send',
    texto_consulta_agencia: 'Send us your query and we will contact you as soon as possible.',
    consulta_enviada: 'We have received your query, we will contact you as soon as possible. Thank you!',

    
 
  
  },
  
}
